import { PPLX_USER_MENTION_PREFIX } from '#pplx/frontend/common/protocols.js';
export function getUserMentionUrl(email) {
    return `${PPLX_USER_MENTION_PREFIX}${email}`;
}
export function getUserMentionTarget(rawUrl) {
    const href = rawUrl.trim();
    if (!href.startsWith(PPLX_USER_MENTION_PREFIX)) {
        return null;
    }
    const email = href.slice(PPLX_USER_MENTION_PREFIX.length);
    return email ? { email } : null;
}
//# sourceMappingURL=userMentionUrl.js.map